import { render, staticRenderFns } from "./Aids.vue?vue&type=template&id=6df99930"
import script from "./Aids.vue?vue&type=script&lang=js"
export * from "./Aids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports